module.exports = __webpack_public_path__ + "img/logo-nft-dark.2b7ef587.png";